/* SnakE-Kollektion, Premium-Familie: Bewegungsebene.
   Additiv: Ohne dieses Skript steht jede Seite fertig da. Hier werden nur Klassen
   gesetzt, die Keyframes ausloesen, Zahlen hochgezaehlt, Bilder leicht verschoben
   und der Spruehnebel gezeichnet. Bei prefers-reduced-motion bleibt alles ruhig,
   nur Tabs und Scroll-Geschichte schalten weiter um. */
(function () {
  if (window.__snkBewegung) return;
  window.__snkBewegung = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var feinzeiger = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = document.documentElement;
  root.classList.add('snk-js');

  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function klemme(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* 1 Einblenden beim Scrollen (Klasse startet Keyframes, Ruhezustand ist sichtbar) */
  alle('[data-snk-staffel]').forEach(function (el) {
    Array.prototype.forEach.call(el.children, function (k, i) { k.style.setProperty('--snk-i', Math.min(i, 9)); });
  });
  if (!ruhig && 'IntersectionObserver' in window) {
    var ein = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('snk-an'); ein.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 6% 0px', threshold: 0 });
    alle('[data-snk-rv],[data-snk-staffel],[data-snk-mark]').forEach(function (el) { ein.observe(el); });
  }

  /* 2 Zahlen zaehlen hoch. Endwert steht im DOM, Animation nur darueber. */
  function formatiere(n, nachkomma) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: nachkomma, maximumFractionDigits: nachkomma });
  }
  function zaehle(el) {
    var ziel = parseFloat(el.getAttribute('data-snk-zahl'));
    if (isNaN(ziel)) return;
    var nk = (el.getAttribute('data-snk-zahl').split('.')[1] || '').length;
    var endtext = el.textContent;
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    var start = null, dauer = 1400;
    function schritt(t) {
      if (!start) start = t;
      var p = klemme((t - start) / dauer, 0, 1);
      var e = 1 - Math.pow(2, -10 * p);
      el.textContent = formatiere(ziel * (p === 1 ? 1 : e), nk);
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endtext;
    }
    requestAnimationFrame(schritt);
  }
  if (!ruhig && 'IntersectionObserver' in window) {
    var zo = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) { zaehle(e.target); zo.unobserve(e.target); } });
    }, { threshold: 0.6 });
    alle('[data-snk-zahl]').forEach(function (el) { zo.observe(el); });
  }

  /* 3 Sichtbarkeit fuer Dauerschleifen (SVG-Wasserfluss etc. laufen nur im Bild) */
  if ('IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('snk-sicht', e.isIntersecting); });
    }, { threshold: 0.05 });
    alle('[data-snk-sicht]').forEach(function (el) { so.observe(el); });
  }

  /* 4 Tiefe (Parallaxe) und Scroll-Fortschritt, ein gemeinsamer rAF-Takt */
  var tiefe = alle('[data-snk-tiefe]');
  var fortschritt = alle('[data-snk-fortschritt]');
  var scrolly = alle('[data-snk-scrolly]');
  var tickt = false;
  function takt() {
    tickt = false;
    var vh = window.innerHeight;
    if (!ruhig) {
      tiefe.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var f = parseFloat(el.getAttribute('data-snk-tiefe')) || 0.1;
        var mitte = r.top + r.height / 2 - vh / 2;
        var grenze = r.height * 0.06;
        el.style.setProperty('--snk-py', klemme(mitte * -f, -grenze, grenze).toFixed(1) + 'px');
      });
    }
    fortschritt.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = klemme((vh * 0.6 - r.top) / Math.max(r.height, 1), 0, 1);
      el.style.setProperty('--snk-p', p.toFixed(3));
    });
  }
  function anstossen() { if (!tickt) { tickt = true; requestAnimationFrame(takt); } }
  if (tiefe.length || fortschritt.length) {
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    takt();
  }

  /* 5 Scroll-Geschichte: der Schritt in Bildmitte schaltet die Buehne um */
  scrolly.forEach(function (box) {
    var schritte = alle('[data-snk-schritt]', box);
    var bilder = alle('[data-snk-buehnenbild]', box);
    var zaehler = box.querySelector('[data-snk-zaehler]');
    function aktiviere(i) {
      schritte.forEach(function (s, k) { s.classList.toggle('ist-aktiv', k === i); });
      bilder.forEach(function (b, k) { b.classList.toggle('ist-aktiv', k === i); });
      if (zaehler) zaehler.textContent = String(i + 1).padStart(2, '0');
      box.style.setProperty('--snk-schritt', i);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) aktiviere(schritte.indexOf(e.target));
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    schritte.forEach(function (s) { io.observe(s); });
  });

  /* 6 Tabs (Navigator, Duesenwahl). Ohne JS stehen alle Panels untereinander. */
  alle('[data-snk-tabs]').forEach(function (box) {
    var leiste = box.querySelector('[data-snk-tableiste]');
    var tabs = alle('[data-snk-tab]', box);
    var panels = alle('[data-snk-panel]', box);
    var marker = box.querySelector('[data-snk-marker]');
    if (!leiste || !tabs.length || tabs.length !== panels.length) return;
    box.classList.add('snk-tabs-an');
    leiste.setAttribute('role', 'tablist');
    function setzeMarker(tab) {
      if (!marker) return;
      marker.style.setProperty('--x', tab.offsetLeft + 'px');
      marker.style.setProperty('--b', tab.offsetWidth + 'px');
      marker.style.setProperty('--y', tab.offsetTop + 'px');
      marker.style.setProperty('--h', tab.offsetHeight + 'px');
    }
    function waehle(i, fokus) {
      tabs.forEach(function (t, k) {
        var an = k === i;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.setAttribute('tabindex', an ? '0' : '-1');
        t.classList.toggle('ist-aktiv', an);
        panels[k].hidden = !an;
        panels[k].classList.toggle('snk-wechsel', an);
      });
      setzeMarker(tabs[i]);
      if (fokus) tabs[i].focus();
      box.style.setProperty('--snk-tab', i);
    }
    tabs.forEach(function (t, i) {
      var id = panels[i].id || ('snk-panel-' + Math.random().toString(36).slice(2, 8));
      panels[i].id = id;
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-controls', id);
      panels[i].setAttribute('role', 'tabpanel');
      panels[i].setAttribute('tabindex', '0');
      t.addEventListener('click', function (ev) { ev.preventDefault(); waehle(i, false); });
      t.addEventListener('keydown', function (ev) {
        var n = null;
        if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') n = (i + 1) % tabs.length;
        if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        if (ev.key === 'Home') n = 0;
        if (ev.key === 'End') n = tabs.length - 1;
        if (n !== null) { ev.preventDefault(); waehle(n, true); }
      });
    });
    waehle(0, false);
    window.addEventListener('resize', function () {
      var aktiv = tabs.filter(function (t) { return t.classList.contains('ist-aktiv'); })[0];
      if (aktiv) setzeMarker(aktiv);
    });
  });

  /* 7 Licht auf Karten, das dem Zeiger folgt */
  if (feinzeiger && !ruhig) {
    document.addEventListener('pointermove', function (ev) {
      var k = ev.target.closest && ev.target.closest('.snk-karte,[data-snk-licht]');
      if (!k) return;
      var r = k.getBoundingClientRect();
      k.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      k.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* 8 Spruehnebel: Partikel steigen aus den Duesenpunkten (rein dekorativ) */
  alle('canvas[data-snk-nebel]').forEach(function (cv) {
    if (ruhig || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var quellen = (cv.getAttribute('data-snk-nebel') || '50,90').split(';').map(function (q) {
      var p = q.split(','); return { x: parseFloat(p[0]) / 100, y: parseFloat(p[1]) / 100 };
    });
    var kegel = parseFloat(cv.getAttribute('data-snk-kegel') || '60') * Math.PI / 180;
    var richtung = (parseFloat(cv.getAttribute('data-snk-richtung') || '-90')) * Math.PI / 180;
    var dichte = parseFloat(cv.getAttribute('data-snk-dichte') || '1');
    var teile = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), laeuft = false, zuletzt = 0;
    function groesse() {
      var r = cv.getBoundingClientRect();
      w = r.width; h = r.height;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function neu() {
      var q = quellen[Math.floor(Math.random() * quellen.length)];
      var a = richtung + (Math.random() - 0.5) * kegel;
      var v = (0.6 + Math.random() * 1.4) * Math.max(h, 300) / 520;
      return { x: q.x * w, y: q.y * h, vx: Math.cos(a) * v, vy: Math.sin(a) * v, r: 1 + Math.random() * 2.4, leben: 0, max: 70 + Math.random() * 90 };
    }
    function bild(t) {
      if (!laeuft) return;
      var dt = Math.min((t - zuletzt) / 16.7, 3); zuletzt = t;
      var soll = Math.round(quellen.length * 34 * dichte);
      while (teile.length < soll) teile.push(neu());
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < teile.length; i++) {
        var p = teile[i];
        p.leben += dt; p.x += p.vx * dt; p.y += p.vy * dt; p.vx *= 0.992; p.vy *= 0.992; p.vy -= 0.004 * dt; p.r += 0.05 * dt;
        var k = p.leben / p.max;
        if (k >= 1) { teile[i] = neu(); continue; }
        var alpha = Math.sin(k * Math.PI) * 0.32;
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3);
        g.addColorStop(0, 'rgba(255,255,255,' + alpha.toFixed(3) + ')');
        g.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3, 0, Math.PI * 2); ctx.fill();
      }
      requestAnimationFrame(bild);
    }
    function start() { if (laeuft) return; laeuft = true; zuletzt = performance.now(); requestAnimationFrame(bild); }
    function stopp() { laeuft = false; }
    groesse();
    window.addEventListener('resize', groesse);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { e[0].isIntersecting && !document.hidden ? start() : stopp(); }, { threshold: 0 }).observe(cv);
    } else { start(); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopp(); });
  });
})();
